import DomainList from './domains/list'
import DomainShow from './domains/show'

const routes = [
  { path: '/', component: DomainList },
  { path: '/:id/:view', component: DomainShow }
]

export default routes
